import { render, staticRenderFns } from "./LegalEntityDetail.vue?vue&type=template&id=390cc3aa&scoped=true&"
import script from "./LegalEntityDetail.vue?vue&type=script&lang=ts&"
export * from "./LegalEntityDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390cc3aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390cc3aa')) {
      api.createRecord('390cc3aa', component.options)
    } else {
      api.reload('390cc3aa', component.options)
    }
    module.hot.accept("./LegalEntityDetail.vue?vue&type=template&id=390cc3aa&scoped=true&", function () {
      api.rerender('390cc3aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_legal-entity/LegalEntityDetail.vue"
export default component.exports